if (!customElements.get("refer-popup")) {
  class ReferPopup extends HTMLElement {
    constructor() {
      super();
      this.closeTimeoutId = null;
      this.openTimeoutId = null;
      this.handleScroll = this.handleScroll.bind(this);
      this._initEvents();
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this.handleScroll);
      clearTimeout(this.closeTimeoutId);
      clearTimeout(this.openTimeoutId);
    }

    _initEvents() {
      this._initClosing();
      this._openingLogic();
      this._referLogic();
    }

    _openingLogic() {
      const closedDate = localStorage.getItem("popupClosedDate");
      const today = new Date().toDateString();

      if (closedDate === today) {
        return;
      }

      window.addEventListener("scroll", this.handleScroll, { passive: true });
    }

    _initClosing() {
      this.querySelectorAll(".js-rp__close-btn, .overlay").forEach((el) => {
        el.addEventListener("click", () => {
          this.close();
        });
      });
    }

    _checkIfReferalPage() {
      if (
        window.location.href.includes("/pages/referral") ||
        localStorage.getItem("customer-page-refered") == "true"
      ) {
        return true;
      }
      return false;
    }

    _referLogic() {}

    handleScroll() {
      if (window.scrollY <= 100) return;

      this.open();
      window.removeEventListener("scroll", this.handleScroll);
    }

    open() {
      if (this._checkIfReferalPage()) {
        return;
      }
      clearTimeout(this.closeTimeoutId);
      this.classList.add("opening");
      this.openTimeoutId = window.setTimeout(() => {
        this.classList.add("open");
        this.classList.remove("opening");
      }, 600);
    }

    close() {
      clearTimeout(this.openTimeoutId);
      this.classList.add("closing");
      this.closeTimeoutId = window.setTimeout(() => {
        this.classList.remove("closing");
        this.classList.remove("open");
      }, 600);
    }
  }

  customElements.define("refer-popup", ReferPopup);
}

if (!customElements.get("finacing-info-popup")) {
  class FinacingInfoPopup extends HTMLElement {
    constructor() {
      super();
      this.variantPrice = Number(this.dataset.price);
      this.closeTimeoutId = null;
      this.pricePerMonthEls = Array.from(
        this.querySelectorAll(".fip__price-per-month, .fip__sub-price"),
      );
      this.variantPriceEls = Array.from(
        this.querySelectorAll(".fip__variant-price"),
      );
      this.handlePriceUpdate = this.handlePriceUpdate.bind(this);
      this.handleTriggerClick = this.handleTriggerClick.bind(this);

      this.querySelectorAll(".fip__btn, .overlay").forEach((closeEl) => {
        closeEl.addEventListener("click", () => {
          this.close();
        });
      });

      document.addEventListener("click", this.handleTriggerClick);
      window.addEventListener("pm-price-update", this.handlePriceUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.handleTriggerClick);
      window.removeEventListener("pm-price-update", this.handlePriceUpdate);
      clearTimeout(this.closeTimeoutId);
    }

    close() {
      this.classList.add("closing");
      this.closeTimeoutId = window.setTimeout(() => {
        this.classList.remove("show");
        this.classList.remove("closing");
      }, 500);
    }

    open() {
      this.classList.add("show");
    }

    handleTriggerClick(event) {
      if (!event.target.closest(".finance-box__open-popup-btn")) return;
      this.open();
    }

    handlePriceUpdate(e) {
      const newPrice = Number(e?.detail?.data?.salePriceCents?.number);
      if (Number.isNaN(newPrice)) return;
      if (this.variantPrice <= newPrice) {
        return;
      }
      if (window.location.pathname == "/cart") {
        return;
      }

      const discountPercentage = 5;
      const discountAmount = (newPrice * discountPercentage) / 100;
      const discountedPrice = newPrice + discountAmount;
      const pricePerMonth = `$${Number(
        (discountedPrice / 12 / 100).toFixed(2),
      ).toLocaleString()}/mo*`;
      const variantPrice = `$${(newPrice / 100).toLocaleString()}`;

      this.pricePerMonthEls.forEach((el) => {
        el.innerHTML = pricePerMonth;
      });

      this.variantPriceEls.forEach((price) => {
        price.innerHTML = variantPrice;
      });
    }
  }

  customElements.define("finacing-info-popup", FinacingInfoPopup);
}

if (!customElements.get("conditions-popup")) {
  class ConditionsPopup extends HTMLElement {
    constructor() {
      super();
      this.closeTimeoutId = null;
      this.handleStatusClick = this.handleStatusClick.bind(this);

      this.querySelectorAll(".cp__btn, .overlay").forEach((closeEl) => {
        closeEl.addEventListener("click", () => {
          this.close();
        });
      });

      document.addEventListener("click", this.handleStatusClick);
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.handleStatusClick);
      clearTimeout(this.closeTimeoutId);
    }

    close() {
      this.classList.add("closing");
      this.closeTimeoutId = window.setTimeout(() => {
        this.classList.remove("show");
        this.classList.remove("closing");
      }, 500);
    }

    open() {
      this.classList.add("show");
    }

    setCondition(condition) {
      this.dataset.condition = condition;
    }

    _openConditionPopup(condition) {
      const conditionPopup = document.querySelector("conditions-popup");
      conditionPopup.setCondition(condition);
      conditionPopup.open();
    }

    handleStatusClick(event) {
      const status = event.target.closest(".cb-filters__condition-status");
      if (!status || !status.classList.contains("selected-status")) {
        return;
      }
      const selectedFilter = status.closest(".ppf-checked");
      if (!selectedFilter?.dataset.value) return;
      this._openConditionPopup(selectedFilter.dataset.value);
    }
  }

  customElements.define("conditions-popup", ConditionsPopup);
}
